import { render, staticRenderFns } from "./UserBioSidebar.vue?vue&type=template&id=64ddf860&scoped=true"
import script from "./UserBioSidebar.vue?vue&type=script&lang=js"
export * from "./UserBioSidebar.vue?vue&type=script&lang=js"
import style0 from "./UserBioSidebar.vue?vue&type=style&index=0&id=64ddf860&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ddf860",
  null
  
)

export default component.exports